import React, { useEffect, useState } from 'react';
import './ManageOrganizations.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
// import apiClient from '../../../server';
import axiosInstance from '../../../axiosInterceptor';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ManageOrganizations = () => {
  const [organizations, setOrganizations] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [editingOrg, setEditingOrg] = useState(null);
  const [orgName, setOrgName] = useState('');
  const [refresh, setrefresh] = useState(false);
  const [users, setUsers] = useState([]);
  const[unacceptedUser,setUnacceptedUser]=useState([]);
  const [assignedCountryIds, setAssignedCountryIds] = useState([]); 


  const handleAdd = () => {
    setEditingOrg(null);
    setOrgName('');
    setShowModal(true);
  };

  const handleEdit = (org) => {
    setEditingOrg(org);
    setOrgName(org.organization_name);
    setShowModal(true);
  };

  const handleDelete = (orgId) => {
    setEditingOrg(orgId);
    setShowConfirmDialog(true);
    };

  const confirmDelete = () => {
    
    axiosInstance.delete(`/delete_admin_organizations/?organizationId=${editingOrg}`).then((response) => {
      // setrefresh(!refresh)
      toast.success(response.data.message);
      setShowConfirmDialog(false);
      //console.log("response",response);
    })
    // .catch(err=>{
    //   console.log("Error: " + err);
    // })
    .catch((err) => {
      setShowConfirmDialog(false);

      // Handle specific backend errors
      if (
        err.response &&
        err.response.data &&
        err.response.data.error &&
        err.response.data.error.includes("violates foreign key constraint")
      ) {
        toast.error("This Organization is assigned to users and cannot be deleted.");
      } else {
        toast.error("Failed to delete role. Please try again.");
      }
    });

  };

  const handleSave = () => {
    
    if (!orgName.trim()) {
      toast.error("Organization name cannot be empty!");
      return;
    }
    if(editingOrg?.organization_id){
      axiosInstance.put("/update_admin_organizations",{neworganizationName : orgName, organizationId : editingOrg?.organization_id}).then((response)=>{
        //console.log("res",response);
        toast.success(response.data.message);
        setShowModal(false);
        // setrefresh(!refresh)
      })
      // .catch(err=>{
      //   //console.log("Error: " + err);
      //   setShowModal(false);
      // })

      .catch(err => {
        // Check for duplicate key error
        console.log("Error: " + err);
      });
    }else{
      axiosInstance.post("/post_admin_organizations/",{organizationName : orgName }).then((response)=>{
        //console.log("res",response);
        toast.success(response.data.message);
        setShowModal(false);
        // setrefresh(!refresh)
      }) .catch(err => {
        // Check for duplicate key error
         if (err.response && err.response.data && err.response.data.error) {
            const errorMessage = err.response.data.error;
          if (errorMessage.includes("duplicate key value violates unique constraint")) {
            toast.error("Organization name already exists. Please choose a different name.");
          } else {
            toast.error("An error occurred while adding the module.");
          }
        } else {
          toast.error("Unable to connect to the server. Please try again.");
        }
        setShowModal(false);
      });
    }

    
  };

  useEffect(() => {

    axiosInstance.get("/get_admin_organizations/").then((response)=>{
      //console.log("res",response);
      setOrganizations(response.data.data)
    }).catch(err=>{
      console.log("Error: " + err);
      
  })
  }, [refresh])

  return (
    <div className="manage-organizations-container">
        <ToastContainer autoClose={20000} />
      <div className="header-organization">
        {/* <h2>Manage Organizations</h2> */}
        <button className='my-2 add-module-btn' onClick={()=>setrefresh(!refresh)}>Refresh Data</button>
        <button className="add-org-btn" onClick={handleAdd}>Add Organization</button>
      </div>

      <table className="organization-table">
        <thead>
          <tr>
            <th>Organization ID</th>
            <th>Organization Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {organizations ? organizations.map((org,index) => (
            <tr key={index}>
              <td>{org.organization_id}</td>
              <td>{org.organization_name}</td>
              <td>
                <button  onClick={() => handleEdit(org)}><FontAwesomeIcon icon={faPenToSquare} className="iconuser" /></button>
                <button className='manage-organization-btn' onClick={() => handleDelete(org.organization_id)}><FontAwesomeIcon icon={faTrash} className="iconuser" /></button>
              </td>
            </tr>
          )) : <><div className='container'>loading....</div></>}
        </tbody>
      </table>

      {/* Modal for Add/Edit Organization */}
      {showModal && (
        <div className="modal-organization">
          <div className="modal-content-organization">
            <h3>{editingOrg ? 'Edit Organization' : 'Add Organization'}</h3>
            <label>Organization Name:</label>
            <input
              type="text"
              value={orgName}
              onChange={(e) => setOrgName(e.target.value)}
              placeholder="Organization Name"
            />
            <div className="modal-footer-organization">
              <button className="btn-organization save-organization" onClick={handleSave}>Save</button>
              <button className=" btn-organization cancel-organization" onClick={() => setShowModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm Delete Dialog */}
      {showConfirmDialog && (
        <div className="modal-organization">
          <div className="modal-content-organization">
            <h3>Confirm Delete</h3>
            <p>Are you sure you want to delete this organization?</p>
            <div className="modal-footer-organization">
              <button className="btn-organization save-organization" onClick={confirmDelete}>Delete</button>
              <button className=" btn-organization cancel-organization" onClick={() => setShowConfirmDialog(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageOrganizations;
